import {ReactNode} from 'react';

export const AddOrdersToShipmentContentLayout = ({children}: {children: ReactNode}) => (
  <div className="h-[600px] overflow-auto border-t-1 border-sw-border bg-sw-background">{children}</div>
);
